"use strict";

/* ------------------------------------------------------------------ *
 * Mapper 6: FFE F4xxx
 * ------------------------------------------------------------------ *
 * 32 KB PRG-ROM switchable at $8000
 * 8 KB CHR-ROM switchable at $0000
 * Mirroring controlled by bit 5 of the register
 */
// FFE F4xxx (FxROM, 32K PRG switch)

function register(Mappers) {
  Mappers[6] = function (nes) {
    this.nes = nes;
  };

  Mappers[6].prototype = new Mappers[0]();

  Mappers[6].prototype.reset = function () {
    Mappers[0].prototype.reset.apply(this);
    this.load32kRomBank(0, 0x8000);
    this.load8kVromBank(0, 0x0000);
  };

  Mappers[6].prototype.write = function (address, value) {
    if (address < 0x8000) {
      Mappers[0].prototype.write.apply(this, arguments);
      return;
    }

    // Register layout (same as AxROM but different bit assignments):
    // Bits 0-2: 32 KB PRG bank (8 banks max)
    // Bits 3-4: 8 KB CHR bank (4 banks max)
    // Bit 5:    Mirroring (0 = vertical, 1 = horizontal)
    var prgBank = value & 0x07;
    var chrBank = (value >> 3) & 0x03;
    var mirroring = (value & 0x20) !== 0;

    this.load32kRomBank(prgBank, 0x8000);
    this.load8kVromBank(chrBank * 2, 0x0000);
    this.setMirroring(
      mirroring
        ? this.nes.rom.HORIZONTAL_MIRRORING
        : this.nes.rom.VERTICAL_MIRRORING,
    );
  };

  Mappers[6].prototype.loadROM = function () {
    if (!this.nes.rom.valid) {
      throw new Error("FFE F4xxx: Invalid ROM! Unable to load.");
    }

    this.reset();
    this.loadCHRROM();
    this.loadBatteryRam();
    this.loadTrainer();
    this.resetIrqHandler();
  };
}

module.exports = { register: register };
